export default "__VITE_ASSET__DpQ30jJJ__"